import { render, staticRenderFns } from "./AppSwitch.vue?vue&type=template&id=7fd04274&"
import script from "./AppSwitch.vue?vue&type=script&lang=ts&"
export * from "./AppSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports